import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';


const handleDragStart = (e) => e.preventDefault();

/*
Create a carouselbanner with items as parameters
*/
export const CarouselBanner = ({ data }) => {
    const image_list = data?.items.map((item, index) => {
        return (
            <div key={index}
                 style={{
                    position: 'relative',
                    textAlign: 'center',
                    color: 'white'
                }}
            >
                <img
                    src={item.img}
                    alt={item.title}
                    onDragStart={handleDragStart}
                    height={980}
                    role="presentation"
                    style={{
                        width: '100%',
                        display: 'block',
                        objectFit: 'cover',

                    }}
                />
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional for better text visibility
                    padding: '10px',
                    borderRadius: '8px',
                    color: item.text_color || 'white',
                }}>
                    <h1 style={{ margin: 0, fontSize: '6em' }}>{item.title}</h1>
                    <p style={{ marginTop: '10px', fontSize: '3em' }}>{item.paragraph}</p>
                </div>
            </div>
        );
    });

    return <AliceCarousel
                mouseTracking
                autoHeight
                autoWidth
                infinite
                autoPlay
                autoPlayInterval={5000}
                disableButtonsControls
                items={image_list}
            />;
}

